<template>
  <div :class="classes()">
    <div :class="`${el}__inner`">
      <Container>
        <div :class="`${el}__top`">
          <a :href="EXTERNAL_ROUTE_HOME" :class="`${el}__image`">
            <img :class="`${el}__logo`" src="@/assets/logo/logo.svg" />
          </a>
          <div :class="`${el}__right`">
            <Button
              v-if="
                !isAuthenticated &&
                !$route.path.includes(ROUTE_SERVICE_CARELEVEL_CALCULATOR) &&
                !$route.path.includes(ROUTE_ANALYSE_CARE_LEVEL) &&
                !($route.path === ROUTE_LOGIN || $route.path === ROUTE_FORGOT_PASSWORD)
              "
              :href="ROUTE_LOGIN"
              :label="$t('navbar.login')"
              :class="`${el}__button`"
              type="outlined"
              small
              @click="
                onClick(
                  $route.path === ROUTE_LOGIN || $route.path === ROUTE_FORGOT_PASSWORD
                    ? $t('navbar.register')
                    : $t('navbar.login')
                )
              "
            />
            <Button
              v-if="isAuthenticated"
              :href="ROUTE_DASHBOARD"
              :label="$t('navbar.dashboard')"
              :class="`${el}__button`"
              type="outlined"
              small
            />
          </div>
        </div>
      </Container>
    </div>
  </div>
</template>

<script>
import Container from '@/objects/Container';
import Button from '@/objects/Button';

import {
  ROUTE_LOGIN,
  ROUTE_FORGOT_PASSWORD,
  ROUTE_DASHBOARD,
  ROUTE_SERVICE_CARELEVEL_CALCULATOR,
  ROUTE_ANALYSE_CARE_LEVEL,
  EXTERNAL_ROUTE_HOME,
} from '@/constants/routes';

import { mapFieldsAuth } from '@/store/mapFields';
import Tracking from '@/helpers/tracking/Tracking';

export default {
  name: 'NavBar',
  props: {
    hideShadow: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    Container,
    Button,
  },
  computed: {
    ...mapFieldsAuth(['isAuthenticated']),
  },
  data() {
    return {
      ROUTE_LOGIN,
      ROUTE_FORGOT_PASSWORD,
      ROUTE_DASHBOARD,
      ROUTE_SERVICE_CARELEVEL_CALCULATOR,
      ROUTE_ANALYSE_CARE_LEVEL,
      EXTERNAL_ROUTE_HOME,
      el: 'c-navBar',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
          [`${el}--hideShadow`]: this.hideShadow,
        };
      },
    };
  },

  methods: {
    onClick(label) {
      let product = '';

      switch (this.$route.name) {
        case 'Home':
          product = 'Landingpage';
          break;
        case 'Register':
          product = 'Registrieren';
          break;
        case 'CareLevelCalculatorAnalysis':
          product = 'Pflegegradanalyse';
          break;
        case 'CareLevelCalculatorIndex':
          product = 'Pflegegradrechner';
          break;
      }

      const trackingLabel = product + '_btn-' + label + '_header';

      if (product !== '') {
        Tracking.trackDatalayer({
          product: product,
          category: 'DPA',
          event: 'button-click',
          label: trackingLabel,
        });
      }
    },
  },
};
</script>
